var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center mb-3"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }